import { render, staticRenderFns } from "./groupPurchase.vue?vue&type=template&id=0c0aa586&scoped=true"
import script from "./groupPurchase.vue?vue&type=script&lang=js"
export * from "./groupPurchase.vue?vue&type=script&lang=js"
import style0 from "./groupPurchase.vue?vue&type=style&index=0&id=0c0aa586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0aa586",
  null
  
)

export default component.exports